import { render, staticRenderFns } from "./SpendmdNews.vue?vue&type=template&id=010e6a76&scoped=true&"
import script from "./SpendmdNews.vue?vue&type=script&lang=js&"
export * from "./SpendmdNews.vue?vue&type=script&lang=js&"
import style0 from "./SpendmdNews.vue?vue&type=style&index=0&id=010e6a76&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010e6a76",
  null
  
)

export default component.exports